import { styled, ToggleButton, Typography } from '@mui/material';

export const ToggledButtons = styled(ToggleButton)(
  ({ theme }) => `
  border: 1px solid ${theme.palette.secondary.light};
    padding: 5px;

  `,
);

export const InputLabel = styled(Typography)(
  () => `
  font-weight: 400;
  margin-bottom: 16px;
`,
);
